<template>
  <div>
    <!-- 砍价记录 -->
    <div class="history-container">
      <div class="title">砍价记录</div>
      <div class="list" v-if="helpList.length">
        <div class="item" v-for="item in helpList" :key="item.id">
          <div class="user">
            <img class="avatar" :src="item.help_user_pic" />
            <span class="name">{{item.help_user_name}}</span>
          </div>
          <div class="price">
            <span>砍掉</span>
            <span>{{item.money}}元</span>
          </div>
        </div>
        <i class="icon-more-history" v-if="isShowMore" @click="handleMoreHelpList"></i>
      </div>
      <div class="not-list" v-else>
        还没有好友抵达现场哦，快去邀请好友助力吧～
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "History",
  props: {
    helpList: Array,
    isShowMore: Boolean
  },
  data() {
    return {
      // isShowMore: false
    };
  },
  components: {},
  methods: {
    handleMoreHelpList() {
      this.$emit("handleMoreHelpList")
    }
  }
};
</script>

<style scoped lang="scss">
/* 砍价记录 */
.history-container {
  padding: 0.3rem;
  margin: 0.3rem auto;
  width: 6.1rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  background: #fff;
  .title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.3rem;
    color: #999;
    margin-bottom: 0.3rem;
    &::after,
    &::before {
      content: "";
      display: block;
      width: 0.6rem;
      height: 0.01px;
      background: #ededed;
    }
    &::after {
      margin-left: 0.18rem;
    }
    &::before {
      margin-right: 0.2rem;
    }
  }
  .list {
    display: flex;
    flex-direction: column;
    // padding-bottom: .3rem;
    .item + .item {
      margin-top: 0.4rem;
    }
    .item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .user {
        display: flex;
        align-items: center;
      }
      .avatar {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        overflow: hidden;
        vertical-align: middle;
      }
      .name {
        margin-left: 0.2rem;
        font-size: 0.24rem;
        color: #333;
        max-width: 3rem;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        display: block;
      }
      .price {
        color: #333;
        font-size: 0.26rem;
        span + span {
          color: #f61e1e;
        }
      }
    }
    .icon-more-history {
      display: block;
      width: .22rem;
      height: .20rem;
      margin: .2rem auto;
      background: url("../../../../static/images/bargain/icon-more-history.png") no-repeat center center / 100% 100%;
    }
  }
  .not-list {
    text-align: center;
    font-size: .24rem;
    font-weight: 400;
    color: rgba(85, 85, 85, 1);
    line-height: .7rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/components/History.vue